import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from './share-class.graphql';
export type GqlSipFieldsFragment = { id: string, numberOfShares?: string | null, numberOfSharesMax?: string | null, identityId: string, proxyId?: string | null, shareIssueRegistrationId: string, paymentStatus: number, paymentKind: number, claim?: string | null, createdAt: string, updatedAt: string, shareClass?: { name: string, voteWeight: string, quantity?: string | null } | null };

export const SipFieldsFragmentDoc = gql`
    fragment SipFields on ShareIssueParticipant {
  id
  numberOfShares
  numberOfSharesMax
  shareClass {
    ...ScFields
  }
  identityId
  proxyId
  shareIssueRegistrationId
  paymentStatus
  paymentKind
  claim
  createdAt
  updatedAt
}
    ${ScFieldsFragmentDoc}`;